import { lazy } from 'react';
import { IEditorProps, Modes, Format } from './types';

const editorImport = import(/* webpackPrefetch: true */ './Editor');
const htmlEditorImport = import(/* webpackPrefetch: true */ './HtmlEditor');

const Editor = lazy(() => editorImport);
const HtmlEditor = lazy(() => htmlEditorImport);

export { Editor, HtmlEditor, IEditorProps, Modes as EditorModes, Format as EditorFormat };
